
import { DivShowAndHideTypes } from './div-show-and-hide.type';

export const showRblKycSection = () =>({
  type: DivShowAndHideTypes.SHOW_RBL_KYC_SECTION,
 
})

export const showBiometricSection = () =>({
  type: DivShowAndHideTypes.SHOW_BIOMETRIC_SECTION,
 
})

export const showRblOtpVerifySection = () =>({
  type: DivShowAndHideTypes.SHOW_RBL_OTP_VERIFY_SECTION,
 
})

export const showIciciOnboardingSection = () =>({
  type: DivShowAndHideTypes.SHOW_ICICI_ONBOARDING_SECTION,
 
})

export const showIciciKycSection = () =>({
  type: DivShowAndHideTypes.SHOW_ICICI_KYC_SECTION,
 
})

export const showIciciKycSuccessSection = () =>({
  type: DivShowAndHideTypes.SHOW_ICICI_KYC_SUCCESS_SECTION,
 
})

export const resetDivShowAndHide ={
  type: DivShowAndHideTypes.RESET
}